import gql from 'graphql-tag'
import { PRODUCT_FILTER_FRAGMENT } from '~/graphql/gql/product/fragments/productFiltersFragment'

export const PRODUCT_COLLECTION_FRAGMENT = gql`
  ${PRODUCT_FILTER_FRAGMENT}
  fragment productCollection on ProductCollection {
    categories {
      id
      title
      imageId
      url
    }
    hasLazyLoadFilters
    filters @include(if: $withFilters) {
      ...productFilter
    }
    breadcrumbs {
      id
      title
      mediaId
      url
      titleFull
    }
    itemsTotalCount
  }
`
